export default (state = [], action) => {
  switch (action.type) {
    case "SET_DETAIL_GREATERREGION":
        return action.payload;
    default:
      return state;
  }
};
